import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum DocumentHandoverMethodId {
  NONE = 0,
  PRINT = 1,
  SEND = 2,
  PRINT_SEND = 3,
}

export class DocumentHandoverMethod extends Codebook<DocumentHandoverMethodId> {
  private constructor(
    id: DocumentHandoverMethodId,
    public readonly label: () => string,
  ) {
    super(id)
  }

  static readonly PRINT = new DocumentHandoverMethod(DocumentHandoverMethodId.PRINT, () =>
    $t('Only print PDF'),
  )
  static readonly SEND = new DocumentHandoverMethod(DocumentHandoverMethodId.SEND, () =>
    $t('Only send by e-mail'),
  )
  static readonly PRINT_SEND = new DocumentHandoverMethod(DocumentHandoverMethodId.PRINT_SEND, () =>
    $t('Both, print & send'),
  )
  static readonly NONE = new DocumentHandoverMethod(DocumentHandoverMethodId.NONE, () =>
    $t('No handover'),
  )

  isPrinting(): boolean {
    return (
      this.id === DocumentHandoverMethodId.PRINT || this.id === DocumentHandoverMethodId.PRINT_SEND
    )
  }

  isSending(): boolean {
    return (
      this.id === DocumentHandoverMethodId.SEND || this.id === DocumentHandoverMethodId.PRINT_SEND
    )
  }
}
